import React from "react";
import RowItem from "./RowItem";
import { deleteTicket } from "../redux/filghtBookApp/actions";
import { useSelector } from "react-redux";

const PreviewSection = () => {
  const selector = useSelector((state) => state.flightApp);
  console.log(selector);

  return (
    <div className="table-container">
      <table className="booking-table">
        <thead className="bg-gray-100/50">
          <tr className="text-black text-left">
            <th>Destination From</th>
            <th>Destination To</th>
            <th className="text-center">Journey Date</th>
            <th className="text-center">Guests</th>
            <th className="text-center">Class</th>
            <th className="text-center">Delete</th>
          </tr>
        </thead>

        <tbody className="divide-y divide-gray-300/20" id="lws-previewBooked">
          {/* Rendering Rows */}
          {selector?.map((item) => {
            return <RowItem key={item?.id} item={item} />;
          })}
        </tbody>
      </table>
    </div>
  );
};

export default PreviewSection;
